import { render, staticRenderFns } from "./editScene.vue?vue&type=template&id=3a96da7a&scoped=true&"
import script from "./editScene.vue?vue&type=script&lang=js&"
export * from "./editScene.vue?vue&type=script&lang=js&"
import style0 from "./editScene.vue?vue&type=style&index=0&id=3a96da7a&prod&lang=scss&"
import style1 from "./editScene.vue?vue&type=style&index=1&id=3a96da7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a96da7a",
  null
  
)

export default component.exports